import { getAppI18nConfig, initI18n } from 'cfgi18n';
import { GetServerSideProps } from 'next';

import { getByUrl, HomePageBody, homePageBodySchema } from 'services/freeform';
import { HeadObject } from 'services/generic';

import { PUBLIC_CORE_APP_URL_ENV } from 'tools/environments';

import { HomePageView } from '@home/components/home-page-view';
import { getRemoteStylesheets } from '@home/utils/remote-stylesheets';

type IndexProps = {
	body: HomePageBody;
	metaData: HeadObject | null;
	locale: string;
	remoteStylesheets?: string[];
};

const emptyHomePageBody: HomePageBody = {
	main: {
		rows: [],
	},
};

export function Index({ body, metaData }: IndexProps) {
	return <HomePageView body={body} metaData={metaData} />;
}

export const getServerSideProps: GetServerSideProps<IndexProps> = async (
	context
) => {
	const locale = context.locale || 'en';
	let body = emptyHomePageBody;
	let metaData: HeadObject | null = null;

	try {
		const { supportedLocales } = await getAppI18nConfig('home');
		await initI18n(locale, supportedLocales);

		const response = await getByUrl('/', locale, 'gb');
		const parsedBody = homePageBodySchema.safeParse(response.body);

		if (!parsedBody.success) {
			console.warn(
				'Homepage body validation warnings',
				parsedBody.error.flatten()
			);
		}

		body = parsedBody.success ? parsedBody.data : emptyHomePageBody;
		metaData = response.head ?? null;
	} catch (error) {
		console.error('Failed to load homepage freeform data', error);
		return { notFound: true };
	}

	const remoteStylesheets = await getRemoteStylesheets(
		body,
		PUBLIC_CORE_APP_URL_ENV || ''
	);

	return {
		props: { body, metaData, locale, remoteStylesheets },
	};
};

export default Index;
